import { Layouts, Responsive, WidthProvider } from "react-grid-layout";

import "react-grid-layout/css/styles.css";
import { useSelector } from "react-redux";
import "react-resizable/css/styles.css";
import useWindowSize from "../../hooks/useWindowSize";
// import GoalDonut from "./GoalDonut";
import GoalLineDay from "./GoalLineDay";
import GoalLineAll from "./GoalLineAll";
import GoalListWidget from "./GoalListWidget";
import GoalVideoListWidget from "./GoalVideoListWidget";
import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import GoalDonut from "./GoalDonut";

const ResponsiveGridLayout = WidthProvider(Responsive);

const layout = [
	{ i: "1", x: 0, y: 0, w: 4, h: 4, static: true },
	{ i: "2", x: 4, y: 0, w: 4, h: 4, static: true },
];

const endedGoalLayout = [
	{ i: "1", x: 0, y: 0, w: 8, h: 4, static: true }
];

const CAROUSEL_TIMEOUT = 60 * 1000;
const MIN_ROW_HEIGHT = 160;
const ratio = 4; // Max 4 rows
const offset = 120; // height of header + margins

type Props = {
	recurrencyType: string
};

const Grid = (props: Props) => {
	const [, height] = useWindowSize();
	const { search } = useLocation();
	const carouselPageParameter = search.match(/carouselPage=(day|all)/)?.[1];
	const {
		error,
		loading,
		data: { chartType, lineChartAutoRotate, metricType, recurrencyType, status },
	} = useSelector((state: any) => state.goal);
	const initialPage =
		recurrencyType !== "day" ? 0 : carouselPageParameter ? { day: 0, all: 1 }[carouselPageParameter] : 0;
	const [carouselPage, setCarouselPage] = useState(initialPage ?? 0);

	const toggleCarousel = useCallback(
		(page) => {
			setCarouselPage(page ?? Number(!carouselPage));
		},
		[carouselPage]
	);

	const getCarouselElements = useCallback((recurrencyType: string) => {
		const carouselElements = [<GoalLineDay onCarouselClick={() => setCarouselPage(1)} />]

		if (recurrencyType !== 'daily') {
			carouselElements.push(<GoalLineAll onCarouselClick={() => setCarouselPage(0)} recurrencyType={recurrencyType}/>);
		}

		return carouselElements;
	}, []);

	useEffect(() => {
		if (chartType !== "line" || props.recurrencyType === 'daily' || carouselPageParameter || !lineChartAutoRotate) return;
		const interval = window.setInterval(toggleCarousel, CAROUSEL_TIMEOUT);
		return () => window.clearInterval(interval);
	}, [toggleCarousel, carouselPageParameter, lineChartAutoRotate, chartType, props.recurrencyType]);

	if (!layout) {
		return <div />;
	}

	const layouts: Layouts = {
		lg: layout,
		md: layout,
	};

	const endedGoalLayouts: Layouts = {
		lg: endedGoalLayout,
		md: endedGoalLayout,
	};

	return (
		(recurrencyType === 'onetime' && status === 'ended') ? (
			<ResponsiveGridLayout
				className="grid"
				layouts={endedGoalLayouts}
				isResizable={false}
				isDraggable={false}
				breakpoints={{ lg: 1000, md: 468 }}
				cols={{ lg: 8, md: 1 }}
				// useCSSTransforms={true}
				// measureBeforeMount={true}
				rowHeight={Math.max(Math.round((height - offset) / ratio), MIN_ROW_HEIGHT)}
				width={1600}
				autoSize={true}
				margin={[10, 10]}
			>
				<div key={1} className="grid__element">
					<div className="grid__element__container">
						<GoalDonut />
					</div>
				</div>
			</ResponsiveGridLayout>
		) : (
			<ResponsiveGridLayout
				className="grid"
				layouts={layouts}
				isResizable={false}
				isDraggable={false}
				breakpoints={{ lg: 1000, md: 468 }}
				cols={{ lg: 8, md: 1 }}
				// useCSSTransforms={true}
				// measureBeforeMount={true}
				rowHeight={Math.max(Math.round((height - offset) / ratio), MIN_ROW_HEIGHT)}
				width={1600}
				autoSize={true}
				margin={[10, 10]}
			>
				<div key={1} className="grid__element">
					<div className="grid__element__container">
						{error ? (
							<h1>Goal not found</h1>
						) : loading ? (
							<div>Loading...</div>
						) : chartType === "line" ? (
							getCarouselElements(props.recurrencyType)[carouselPage]
						) : (
							<GoalDonut />
						)}
					</div>
				</div>
				<div key={2} className="grid__element">
					<div className="grid__element__container">
						{metricType === "videoPageViews" ? <GoalVideoListWidget /> : <GoalListWidget />}
					</div>
				</div>
			</ResponsiveGridLayout>
		)
	);
};

export default Grid;
